export default __webpack_public_path__ + "static/partnersHeading-5dd34499451bf6942149e12151357c2b.svg";